import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/layout/ScrollToTop";
import { BalkanFinXpertPage } from "./pages/BalkanFinXpertPage";
import {
  AboutPage,
  ContactsPage,
  FindUsPage,
  PartnersPage,
  ServicesPage,
  TeamPage,
} from "./pages/SectionPages";

function App(): React.ReactElement {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<BalkanFinXpertPage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/find-us" element={<FindUsPage />} />
        <Route path="/contact" element={<ContactsPage />} />
        <Route path="/za-nas" element={<Navigate to="/about-us" replace />} />
        <Route path="/uslugi" element={<Navigate to="/services" replace />} />
        <Route path="/ekip" element={<Navigate to="/team" replace />} />
        <Route path="/partnyori" element={<Navigate to="/partners" replace />} />
        <Route path="/kak-da-ni-namerete" element={<Navigate to="/find-us" replace />} />
        <Route path="/kontakti" element={<Navigate to="/contact" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
